const contentAbout = () => import('@/pages/content/about/index.vue');

export default [{
    path: '/content/about',
    component: contentAbout,
    meta: [{
        name: '内容管理',
		activeRoute: '/content/manage'
    },
    {
        name: '关于我们',
        activeRoute: '/content/about'
    }]
}];